import { StatColumn, TextVariant } from "@bridgesplit/ui";
import { ExternalYieldSource } from "@bridgesplit/abf-sdk";
import { useTransactionFeeStat } from "app/components/transactions";
import { TransactionTypes } from "app/types";

import { useMarketLendContext } from "./MarketLendContext";

const VARIANT: TextVariant = "body2";

export default function LendStats() {
    const { form } = useMarketLendContext();
    const externalYieldDisabled = form.yieldSource === ExternalYieldSource.None;

    const transactionFeeStat = useTransactionFeeStat({
        transactionType: externalYieldDisabled ? TransactionTypes.MarketLend : TransactionTypes.MarketLendExternalYield,
        variant: VARIANT
    });

    return <StatColumn stats={[transactionFeeStat]} loading={false} />;
}
